import type { APIData } from 'webapp-types';

import type InfolayerItemGeneral from 'webapp/models-custom/infolayer-item/general';

export const DATASET_GROUP_TYPE_MERGED = 'merged_dataset' as const;

export function showTemplateCreationResult(
	layer: InfolayerItemGeneral,
	reply: APIData.Templates.ResolutionResult | void,
	objectTypeString: string,
): void {
	if (reply?.partialResolution) {
		const reasons = reply.failedReasons?.join(' ') || '';
		const count = reply.failedDatasetCount || 'some';
		layer.warning(
			`${objectTypeString} created, but ${count} dataset(s) couldn't be set up automatically.` +
				(reasons ? ` Reason: ${reasons}` : '') +
				` The affected blocks were left empty — you'll need to add metrics to them manually.`,
		);
	} else {
		layer.ok(`${objectTypeString} successfully built!`);
	}
}
